<mat-progress-bar [style.visibility]="loading ? 'visible' : 'hidden'"
  mode="indeterminate">
</mat-progress-bar>
<form [formGroup]="form"
  (submit)="submit(form.value)">
  <mat-form-field>
    <input matInput
      type="email"
      formControlName="email"
      placeholder="Email Address">

    <mat-error *ngIf="email.hasError('email') && !email.hasError('required')">
      Email is <strong>invalid</strong>
    </mat-error>
    <mat-error *ngIf="email.hasError('required')">
      Email is <strong>required</strong>
    </mat-error>
  </mat-form-field><br>

  <ca-role-select placeholder="Role"
    formControlName="role"
    [options]="roleOptions"></ca-role-select><br><br>

  <button mat-flat-button
    [disabled]="disabled"
    color="primary"
    type="submit">Send Invitation</button>
  <mat-error *ngIf="error">
    Failed to send invitation.
  </mat-error>
</form>